import '@fontsource/inter/cyrillic-400.css'
import '@fontsource/inter/cyrillic-500.css'
import '@fontsource/inter/cyrillic-600.css'
import '@fontsource/onest/cyrillic-600.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/onest/latin-600.css'
import { createPinia } from 'pinia'

import '../../styles/main.scss'
import { createApp } from 'vue'

import { CONFIG_SYMBOL } from '@/shared/config'

if (import.meta.env.DEV) {
    const msw = await import('@/app/mocks')
    await msw.setup()
}

import { userDataModel } from '@/entities/user-data'

import App from './App.vue'

const pinia = createPinia()

const app = createApp(App)
app.use(pinia)
app.provide(CONFIG_SYMBOL, window._CONFIG)

const store = userDataModel.useModel()
await store.fetchUserData()

app.mount('#app')
